(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const initCardPromoRotators = (root = document) => {
    qsa('[data-card-promo-rotator]', root).forEach((rotator) => {
      if (rotator.dataset.cardPromoReady === 'true') return;
      rotator.dataset.cardPromoReady = 'true';

      const messages = qsa('[data-card-promo-message]', rotator);
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (messages.length < 2 || reduceMotion) return;

      const interval = Math.max(Number(rotator.dataset.cardPromoInterval) || 4000, 2000);
      let activeIndex = 0;
      let timer;

      const showMessage = (nextIndex) => {
        messages.forEach((message, index) => {
          const isActive = index === nextIndex;
          message.classList.toggle('is-active', isActive);
          message.setAttribute('aria-hidden', String(!isActive));
        });
        activeIndex = nextIndex;
      };

      const start = () => {
        window.clearInterval(timer);
        timer = window.setInterval(() => {
          showMessage((activeIndex + 1) % messages.length);
        }, interval);
      };

      const stop = () => window.clearInterval(timer);

      rotator.addEventListener('mouseenter', stop);
      rotator.addEventListener('mouseleave', start);
      rotator.addEventListener('focusin', stop);
      rotator.addEventListener('focusout', start);
      start();
    });
  };

  const initCardStockNotify = (root = document) => {
    qsa('[data-card-stock-notify]', root).forEach((component) => {
      if (component.dataset.cardStockNotifyReady === 'true') return;
      component.dataset.cardStockNotifyReady = 'true';

      const dialog = qs('[data-card-notify-dialog]', component);
      const openButton = qs('[data-card-notify-open]', component);
      if (!dialog || !openButton) return;

      const closeDialog = () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      };

      openButton.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        const emailField = qs('input[type="email"]', dialog);
        if (emailField) emailField.focus();
      });

      qsa('[data-card-notify-close]', component).forEach((button) => {
        button.addEventListener('click', closeDialog);
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
    });
  };

  initCardPromoRotators();
  initCardStockNotify();

  const wishlistStorageKey = 'brotherMartWishlist';
  let memoryWishlist = [];

  const readWishlist = () => {
    try {
      const storedWishlist = JSON.parse(window.localStorage.getItem(wishlistStorageKey) || '[]');
      if (Array.isArray(storedWishlist)) {
        memoryWishlist = storedWishlist;
        return storedWishlist;
      }
    } catch (error) {
      // Keep the wishlist usable for this page if storage is unavailable.
    }
    return memoryWishlist;
  };

  const writeWishlist = (wishlist) => {
    memoryWishlist = wishlist;
    try {
      window.localStorage.setItem(wishlistStorageKey, JSON.stringify(wishlist));
    } catch (error) {
      // Private browsing can prevent storage; the active state still responds.
    }
  };

  qsa('[data-wishlist-toggle]').forEach((button) => {
    const productId = button.dataset.productId;
    const productTitle = button.dataset.productTitle || 'This product';
    const productUrl = button.dataset.productUrl || window.location.pathname;
    const notice = button.parentElement && qs('[data-wishlist-notice]', button.parentElement);
    let noticeTimer;

    if (!productId) return;

    const setSavedState = (isSaved) => {
      button.classList.toggle('is-active', isSaved);
      button.setAttribute('aria-pressed', String(isSaved));
      button.setAttribute(
        'aria-label',
        isSaved ? `Remove ${productTitle} from wishlist` : `Save ${productTitle} to wishlist`
      );
    };

    const announceState = (isSaved) => {
      if (!notice) return;
      window.clearTimeout(noticeTimer);
      notice.textContent = isSaved ? 'Saved to wishlist' : 'Removed from wishlist';
      notice.hidden = false;
      window.requestAnimationFrame(() => notice.classList.add('is-visible'));
      noticeTimer = window.setTimeout(() => {
        notice.classList.remove('is-visible');
        window.setTimeout(() => {
          notice.hidden = true;
        }, 180);
      }, 1800);
    };

    const isSaved = readWishlist().some((item) => String(item.id) === productId);
    setSavedState(isSaved);

    button.addEventListener('click', () => {
      const wishlist = readWishlist();
      const existingIndex = wishlist.findIndex((item) => String(item.id) === productId);
      const willSave = existingIndex === -1;

      if (willSave) {
        wishlist.push({ id: productId, title: productTitle, url: productUrl });
      } else {
        wishlist.splice(existingIndex, 1);
      }

      writeWishlist(wishlist);
      setSavedState(willSave);
      announceState(willSave);
    });
  });

  qsa('[data-mobile-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = qs('[data-mobile-menu]');
      if (!menu) return;
      const isHidden = menu.hasAttribute('hidden');
      menu.toggleAttribute('hidden', !isHidden);
      qsa('[data-mobile-menu-toggle]').forEach((toggle) => {
        toggle.setAttribute('aria-expanded', String(isHidden));
      });
    });
  });

  const pickupModal = qs('[data-pickup-modal]');
  const pickupOpenButtons = qsa('[data-pickup-open]');
  const pickupLabels = qsa('[data-location-label]');
  const pickupStorageKey = 'brotherMartPickupLocation';

  if (pickupLabels.length) {
    try {
      const savedLocation = window.localStorage.getItem(pickupStorageKey);
      if (savedLocation) {
        pickupLabels.forEach((label) => {
          label.textContent = savedLocation;
        });
      }
    } catch (error) {
      // Local storage may be blocked in some browsers.
    }
  }

  const openPickupModal = () => {
    if (!pickupModal) return;
    pickupModal.hidden = false;
    document.documentElement.classList.add('has-modal-open');
    const firstInput = qs('input[name="pickup-store"]', pickupModal);
    if (firstInput) firstInput.focus();
  };

  const closePickupModal = () => {
    if (!pickupModal) return;
    pickupModal.hidden = true;
    document.documentElement.classList.remove('has-modal-open');
    if (pickupOpenButtons[0]) pickupOpenButtons[0].focus();
  };

  if (pickupOpenButtons.length && pickupModal) {
    pickupOpenButtons.forEach((button) => {
      button.addEventListener('click', openPickupModal);
    });
    qsa('[data-pickup-close]', pickupModal).forEach((button) => {
      button.addEventListener('click', closePickupModal);
    });
    qsa('[data-pickup-select]', pickupModal).forEach((button) => {
      button.addEventListener('click', () => {
        const label = button.dataset.storeLabel || 'Putalisadak selected';
        pickupLabels.forEach((item) => {
          item.textContent = label;
        });
        try {
          window.localStorage.setItem(pickupStorageKey, label);
        } catch (error) {
          // Local storage may be blocked in some browsers.
        }
        closePickupModal();
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !pickupModal.hidden) closePickupModal();
    });
  }

  const repairModal = qs('[data-repair-modal]');
  const repairOpenButtons = qsa('[data-repair-modal-open]');

  const closeMobileMenu = () => {
    const menu = qs('[data-mobile-menu]');
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    qsa('[data-mobile-menu-toggle]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
  };

  const openRepairModal = () => {
    if (!repairModal) return;
    if (pickupModal && !pickupModal.hidden) closePickupModal();
    closeMobileMenu();
    repairModal.hidden = false;
    document.documentElement.classList.add('has-modal-open');
    const firstField = qs('input:not([type="hidden"]), textarea, select, button', repairModal);
    if (firstField) firstField.focus();
  };

  const closeRepairModal = () => {
    if (!repairModal) return;
    repairModal.hidden = true;
    document.documentElement.classList.remove('has-modal-open');
    if (repairOpenButtons[0]) repairOpenButtons[0].focus();
  };

  if (repairModal && repairOpenButtons.length) {
    repairOpenButtons.forEach((button) => {
      button.addEventListener('click', openRepairModal);
    });
    qsa('[data-repair-modal-close]', repairModal).forEach((button) => {
      button.addEventListener('click', closeRepairModal);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !repairModal.hidden) closeRepairModal();
    });
  }

  const categoryToggle = qs('[data-category-menu-toggle]');
  const categoryDropdown = qs('[data-category-dropdown]');

  if (categoryToggle && categoryDropdown) {
    const closeCategoryDropdown = () => {
      categoryDropdown.hidden = true;
      categoryToggle.setAttribute('aria-expanded', 'false');
    };

    categoryToggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = !categoryDropdown.hidden;
      categoryDropdown.hidden = isOpen;
      categoryToggle.setAttribute('aria-expanded', String(!isOpen));
    });

    categoryDropdown.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    document.addEventListener('click', closeCategoryDropdown);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeCategoryDropdown();
    });
  }

  qsa('.site-nav__item--has-dropdown > .site-nav__link').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (!window.matchMedia('(hover: none)').matches) return;
      const item = link.closest('.site-nav__item');
      if (!item || item.classList.contains('is-open')) return;
      event.preventDefault();
      qsa('.site-nav__item.is-open').forEach((openItem) => openItem.classList.remove('is-open'));
      item.classList.add('is-open');
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.site-nav__item')) return;
    qsa('.site-nav__item.is-open').forEach((openItem) => openItem.classList.remove('is-open'));
  });

  qsa('[data-deal-hub]').forEach((hub) => {
    const select = qs('[data-deal-select]', hub);
    const triggers = qsa('[data-deal-trigger]', hub);
    const panels = qsa('[data-deal-panel]', hub);
    const viewAll = qs('[data-deal-view-all]', hub);

    if (!panels.length) return;

    const showDealPanel = (panelId, selectedLink) => {
      const currentPanel = panels.find((panel) => panel.dataset.dealPanel === panelId);
      if (!currentPanel) return;

      panels.forEach((panel) => {
        panel.hidden = panel !== currentPanel;
      });
      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.dealTrigger === panelId;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-pressed', String(isActive));
      });

      if (viewAll) {
        viewAll.href = selectedLink || currentPanel.dataset.dealLink || viewAll.href;
      }
    };

    if (select) {
      select.addEventListener('change', () => {
        const selectedOption = select.options[select.selectedIndex];
        showDealPanel(select.value, selectedOption && selectedOption.dataset.dealLink);
      });
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        showDealPanel(trigger.dataset.dealTrigger, trigger.dataset.dealLink);
      });
    });
  });

  qsa('[data-scroll-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const section = button.closest('section');
      const rail = section && qs('[data-scroll-container]', section);
      if (!rail) return;
      const direction = button.dataset.scrollButton === 'prev' ? -1 : 1;
      rail.scrollBy({ left: direction * Math.max(280, rail.clientWidth * 0.8), behavior: 'smooth' });
    });
  });

  qsa('[data-full-hero-slider]').forEach((slider) => {
    const track = qs('.hero-image-slider__track', slider);
    const slides = qsa('.hero-image-slide', slider);
    const dots = qsa('[data-full-hero-dot]', slider);
    const interval = Number(slider.dataset.interval) || 5000;
    let index = 0;
    let isPaused = false;

    if (!track || slides.length <= 1) return;

    const showSlide = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        showSlide(Number(dot.dataset.fullHeroDot) || 0);
      });
    });

    slider.addEventListener('mouseenter', () => {
      isPaused = true;
    });
    slider.addEventListener('mouseleave', () => {
      isPaused = false;
    });

    window.setInterval(() => {
      if (isPaused || document.hidden) return;
      showSlide(index + 1);
    }, interval);
  });

  qsa('[data-hero-card-slider]').forEach((slider) => {
    const track = qs('.hero-card-slider__track', slider);
    const slides = qsa('.hero-card-slider__slide', slider);
    const card = slider.closest('.hero-carousel-card');
    const dots = card ? qsa('[data-hero-slider-dot]', card) : [];
    const interval = Number(slider.dataset.interval) || 4000;
    let index = 0;
    let isPaused = false;

    if (!track || slides.length <= 1) return;

    const showSlide = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        showSlide(Number(dot.dataset.heroSliderDot) || 0);
      });
    });

    if (card) {
      card.addEventListener('mouseenter', () => {
        isPaused = true;
      });
      card.addEventListener('mouseleave', () => {
        isPaused = false;
      });
    }

    window.setInterval(() => {
      if (isPaused || document.hidden) return;
      showSlide(index + 1);
    }, interval);
  });

  qsa('[data-showcase-banner-slider]').forEach((slider) => {
    const track = qs('.everyday-banner-slider__track', slider);
    const slides = qsa('[data-showcase-banner-slide]', slider);
    const dots = qsa('[data-showcase-banner-dot]', slider);
    const interval = Number(slider.dataset.interval) || 5000;
    let index = 0;
    let isPaused = false;

    if (!track || slides.length <= 1) return;

    const showSlide = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        showSlide(Number(dot.dataset.showcaseBannerDot) || 0);
      });
    });

    slider.addEventListener('mouseenter', () => {
      isPaused = true;
    });
    slider.addEventListener('mouseleave', () => {
      isPaused = false;
    });

    window.setInterval(() => {
      if (isPaused || document.hidden) return;
      showSlide(index + 1);
    }, interval);
  });

  const filterToggle = qs('[data-filter-toggle]');
  const filterPanel = qs('[data-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', () => filterPanel.classList.toggle('is-open'));
  }

  qsa('[data-expandable-text]').forEach((container) => {
    const preview = qs('[data-expandable-preview]', container);
    const full = qs('[data-expandable-full]', container);
    const toggle = qs('[data-expandable-toggle]', container);
    if (!preview || !full || !toggle) return;

    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      preview.hidden = !isExpanded;
      full.hidden = isExpanded;
      toggle.textContent = isExpanded ? 'Show more' : 'Show less';
    });
  });

  qsa('[data-brand-logo-image]').forEach((image) => {
    image.addEventListener('error', () => {
      const mark = image.closest('.collection-brand-logo__mark, .brand-tile__logo');
      if (mark) mark.classList.add('is-missing');
    });
  });

  qsa('[data-product-promo]').forEach((promotions) => {
    const input = qs('[data-promo-code-input]', promotions);
    const submit = qs('[data-promo-code-submit]', promotions);
    const result = qs('[data-promo-code-result]', promotions);
    const offers = qsa('[data-promo-offer-code]', promotions);
    const copyButtons = qsa('[data-promo-copy-code]', promotions);
    const knownCodes = offers.map((offer) => offer.dataset.promoOfferCode.trim().toUpperCase());

    const showResult = (text, status) => {
      if (!result) return;
      result.textContent = text;
      result.classList.toggle('is-valid', status === 'valid');
      result.classList.toggle('is-unlisted', status === 'unlisted');
    };

    const checkCode = () => {
      if (!input) return;
      const enteredCode = input.value.trim().toUpperCase();
      if (!enteredCode) {
        showResult('Enter a code to check the offers listed for this product.', 'unlisted');
        return;
      }

      if (knownCodes.includes(enteredCode)) {
        showResult(`${enteredCode} is listed for this product. Final eligibility and discount are confirmed at checkout.`, 'valid');
      } else {
        showResult('This code is not listed in the offers for this product. You can still try an active store discount at checkout.', 'unlisted');
      }
    };

    if (submit && input) {
      submit.addEventListener('click', checkCode);
      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        checkCode();
      });
    }

    copyButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const code = button.dataset.promoCopyCode;
        if (!code) return;
        if (input) input.value = code;
        try {
          await navigator.clipboard.writeText(code);
          showResult(`${code} copied. Final eligibility and discount are confirmed at checkout.`, 'valid');
        } catch (error) {
          showResult(`${code} is listed for this product. Enter it at checkout to apply the offer.`, 'valid');
        }
      });
    });
  });

  qsa('[data-emi-calculator]').forEach((calculator) => {
    const form = calculator.closest('form');
    const productInfo = calculator.closest('.product-info');
    const toggle = qs('[data-emi-toggle]', calculator);
    const panel = qs('[data-emi-panel]', calculator);
    const principalInput = qs('[data-emi-principal]', calculator);
    const rateInput = qs('[data-emi-rate]', calculator);
    const monthsInput = qs('[data-emi-months]', calculator);
    const monthlyResult = qs('[data-emi-monthly]', calculator);
    const interestResult = qs('[data-emi-interest]', calculator);
    const totalResult = qs('[data-emi-total]', calculator);
    const preview = productInfo && qs('[data-emi-monthly-preview]', productInfo);
    const teaser = productInfo && qs('[data-emi-teaser]', productInfo);
    const currentPrice = productInfo && qs('.product-info__price .price__current', productInfo);
    const variantSelect = form && qs('[data-product-variant-select]', form);
    const principalProperty = qs('[data-emi-property-principal]', calculator);
    const rateProperty = qs('[data-emi-property-rate]', calculator);
    const monthsProperty = qs('[data-emi-property-months]', calculator);
    const monthlyProperty = qs('[data-emi-property-monthly]', calculator);
    const productSubmit = qs('[data-product-submit]', form);
    const propertyInputs = [principalProperty, rateProperty, monthsProperty, monthlyProperty].filter(Boolean);
    const minimumPriceCents = Number(calculator.dataset.minimumPriceCents) || 0;
    const currencyLabel = calculator.dataset.currencyLabel || 'Rs';
    let variantPriceCents = Number(calculator.dataset.initialPriceCents) || 0;

    if (!form || !toggle || !panel || !principalInput || !rateInput || !monthsInput) return;
    const productSubmitText = productSubmit ? productSubmit.textContent.trim() : '';

    const formatMoney = (amount) => {
      const rounded = Math.round(Number(amount) || 0);
      return `${currencyLabel} ${rounded.toLocaleString('en-IN')}`;
    };

    const setPropertyState = (isEnabled) => {
      propertyInputs.forEach((input) => {
        input.disabled = !isEnabled;
      });
    };

    const calculateEmi = () => {
      const principal = Math.max(0, Number(principalInput.value) || 0);
      const annualRate = Math.max(0, Number(rateInput.value) || 0);
      const months = Math.max(1, Number(monthsInput.value) || 1);
      const monthlyRate = annualRate / 1200;
      const monthlyPayment = monthlyRate === 0
        ? principal / months
        : principal * monthlyRate * Math.pow(1 + monthlyRate, months) / (Math.pow(1 + monthlyRate, months) - 1);
      const totalPayable = monthlyPayment * months;
      const totalInterest = totalPayable - principal;
      const monthlyText = formatMoney(monthlyPayment);

      if (monthlyResult) monthlyResult.textContent = monthlyText;
      if (interestResult) interestResult.textContent = formatMoney(totalInterest);
      if (totalResult) totalResult.textContent = formatMoney(totalPayable);
      if (preview) preview.textContent = `${monthlyText}/month`;

      if (principalProperty) principalProperty.value = formatMoney(principal);
      if (rateProperty) rateProperty.value = `${annualRate}% yearly`;
      if (monthsProperty) monthsProperty.value = `${months} months`;
      if (monthlyProperty) monthlyProperty.value = `${monthlyText}/month (estimated)`;
    };

    const setEligibility = (priceCents) => {
      variantPriceCents = priceCents;
      const isEligible = variantPriceCents >= minimumPriceCents;

      calculator.hidden = !isEligible;
      if (teaser) teaser.hidden = !isEligible;
      toggle.disabled = !isEligible;
      if (!isEligible) {
        calculator.open = false;
        toggle.checked = false;
        panel.hidden = true;
        setPropertyState(false);
        form.classList.remove('is-emi-selected');
        if (productSubmit) productSubmit.textContent = productSubmitText;
      }

      principalInput.value = (variantPriceCents / 100).toFixed(0);
      calculateEmi();
    };

    toggle.addEventListener('change', () => {
      panel.hidden = !toggle.checked;
      setPropertyState(toggle.checked);
      form.classList.toggle('is-emi-selected', toggle.checked);
      if (productSubmit) {
        productSubmit.textContent = toggle.checked ? 'Add EMI Request to Cart' : productSubmitText;
      }
      calculateEmi();
    });

    [principalInput, rateInput, monthsInput].forEach((input) => {
      input.addEventListener('input', calculateEmi);
      input.addEventListener('change', calculateEmi);
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        const selectedPriceCents = Number(selectedOption.dataset.priceCents) || 0;
        if (currentPrice && selectedOption.dataset.priceLabel) {
          currentPrice.textContent = selectedOption.dataset.priceLabel;
        }
        setEligibility(selectedPriceCents);
      });
    }

    setPropertyState(false);
    setEligibility(variantPriceCents);
  });

  qsa('[data-sticky-product-bar]').forEach((bar) => {
    const productSection = bar.closest('.main-product');
    const sourceButton = productSection && qs('[data-product-submit]', productSection);
    const stickyButton = qs('[data-sticky-product-submit]', bar);
    const sourcePrice = productSection && qs('.product-info__price .price__current', productSection);
    const stickyPrice = qs('[data-sticky-product-price]', bar);
    const variantSelect = productSection && qs('[data-product-variant-select]', productSection);
    let sourceButtonVisible = true;

    if (!sourceButton || !stickyButton) return;

    const syncStickyCart = () => {
      stickyButton.disabled = sourceButton.disabled;
      stickyButton.textContent = sourceButton.textContent.trim();
      if (sourcePrice && stickyPrice) stickyPrice.textContent = sourcePrice.textContent.trim();
    };

    const updateStickyVisibility = () => {
      const shouldShow = !sourceButtonVisible && window.scrollY > 120;
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', String(!shouldShow));
      document.body.classList.toggle('has-sticky-cart-visible', shouldShow);
    };

    stickyButton.addEventListener('click', () => {
      sourceButton.click();
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        window.setTimeout(syncStickyCart, 0);
      });
    }

    new MutationObserver(syncStickyCart).observe(sourceButton, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        sourceButtonVisible = entries[0].isIntersecting;
        updateStickyVisibility();
      }).observe(sourceButton);
    }

    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    syncStickyCart();
    updateStickyVisibility();
  });

  qsa('[data-tabs]').forEach((tabs) => {
    const buttons = qsa('[data-tab-button]', tabs);
    const root = tabs.parentElement;
    const panels = qsa('[data-tab-panel]', root);
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.tabButton;
        buttons.forEach((item) => item.classList.toggle('is-active', item === button));
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.tabPanel === target));
      });
    });
  });

  qsa('[data-product-gallery]').forEach((gallery) => {
    const media = gallery.closest('.product-media');
    const track = qs('[data-product-media-track]', gallery);
    const slides = qsa('[data-product-media-slide]', gallery);
    const thumbsRail = media && qs('[data-product-thumbs]', media);
    const thumbs = media ? qsa('[data-product-media-target]', media) : [];
    const prevButton = qs('[data-product-media-prev]', gallery);
    const nextButton = qs('[data-product-media-next]', gallery);
    let currentIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let scrollFrame = 0;

    if (!track || !slides.length) return;

    const setActive = (index) => {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === currentIndex);
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === currentIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', String(isActive));
        if (isActive && thumbsRail) {
          const thumbStart = thumb.offsetLeft;
          const thumbEnd = thumbStart + thumb.offsetWidth;
          const railStart = thumbsRail.scrollLeft;
          const railEnd = railStart + thumbsRail.clientWidth;
          if (thumbStart < railStart || thumbEnd > railEnd) {
            thumbsRail.scrollTo({ left: Math.max(0, thumbStart - 10), behavior: 'smooth' });
          }
        }
      });
      if (prevButton) prevButton.disabled = currentIndex === 0;
      if (nextButton) nextButton.disabled = currentIndex === slides.length - 1;
    };

    const showSlide = (index, behavior = 'smooth') => {
      const boundedIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({
        left: slides[boundedIndex].offsetLeft,
        behavior
      });
      setActive(boundedIndex);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        showSlide(Number(thumb.dataset.productMediaTarget) || 0);
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', () => showSlide(currentIndex - 1));
    }
    if (nextButton) {
      nextButton.addEventListener('click', () => showSlide(currentIndex + 1));
    }

    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        slides.forEach((slide, slideIndex) => {
          const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = slideIndex;
          }
        });
        setActive(closestIndex);
      });
    }, { passive: true });

    window.addEventListener('resize', () => {
      showSlide(currentIndex, 'auto');
    });

    showSlide(currentIndex, 'auto');
  });

  qsa('[data-brand-directory]').forEach((directory) => {
    const triggers = qsa('[data-brand-trigger]', directory);
    const panels = qsa('[data-brand-panel]', directory);
    const display = qs('[data-brand-display]', directory);
    const search = qs('[data-brand-search]', directory);
    const noResults = qs('[data-brand-no-results]', directory);
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const feedCache = new Map();
    let lastTrigger = triggers[0] || null;

    if (!triggers.length || !panels.length || !display) return;

    const renderCollection = async (panel, url) => {
      const products = qs('[data-brand-products]', panel);
      if (!products || !url || products.dataset.loadedUrl === url) return;

      products.setAttribute('aria-busy', 'true');
      products.innerHTML = '<div class="brand-directory__loading">Loading products...</div>';

      try {
        let content = feedCache.get(url);
        if (!content) {
          const separator = url.includes('?') ? '&' : '?';
          const response = await fetch(`${url}${separator}section_id=brand-product-feed`);
          if (!response.ok) throw new Error('Products could not be loaded.');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const feed = html.querySelector('[data-brand-product-feed]');
          if (!feed) throw new Error('Product feed not found.');
          content = feed.innerHTML;
          feedCache.set(url, content);
        }
        products.innerHTML = content;
        initCardPromoRotators(products);
        products.dataset.loadedUrl = url;
      } catch (error) {
        products.innerHTML = `<div class="brand-directory__products-empty"><p>Products could not be loaded.</p><a href="${url}">Browse this category</a></div>`;
      } finally {
        products.removeAttribute('aria-busy');
      }
    };

    const activateGroup = (panel, group) => {
      if (!group) {
        renderCollection(panel, panel.dataset.brandDefaultUrl);
        return;
      }
      qsa('[data-brand-group-url]', panel).forEach((item) => {
        const isActive = item === group;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
      });
      renderCollection(panel, group.dataset.brandGroupUrl);
    };

    const closeDrawer = () => {
      display.classList.remove('is-open');
      document.documentElement.classList.remove('has-modal-open');
      if (lastTrigger) lastTrigger.focus();
    };

    const activateBrand = (handle, openDrawer) => {
      const selectedPanel = panels.find((panel) => panel.dataset.brandPanel === handle);
      if (!selectedPanel) return;

      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.brandTrigger === handle;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', String(isActive));
        if (isActive) lastTrigger = trigger;
      });

      panels.forEach((panel) => {
        const isActive = panel === selectedPanel;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      activateGroup(selectedPanel, qs('[data-brand-group-url].is-active', selectedPanel));

      if (openDrawer && mobileQuery.matches) {
        display.classList.add('is-open');
        document.documentElement.classList.add('has-modal-open');
        const closeButton = qs('.brand-directory__drawer-header [data-brand-close]', display);
        if (closeButton) closeButton.focus();
      }
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        activateBrand(trigger.dataset.brandTrigger, true);
      });
    });

    panels.forEach((panel) => {
      qsa('[data-brand-group-url]', panel).forEach((group) => {
        group.addEventListener('click', () => activateGroup(panel, group));
      });
    });

    qsa('[data-brand-close]', display).forEach((button) => {
      button.addEventListener('click', closeDrawer);
    });

    if (search) {
      search.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();
        let firstVisible = null;

        triggers.forEach((trigger) => {
          const matches = !query || trigger.dataset.brandName.includes(query);
          trigger.hidden = !matches;
          if (matches && !firstVisible) firstVisible = trigger;
        });

        if (noResults) noResults.hidden = Boolean(firstVisible);

        const activeTrigger = triggers.find((trigger) => trigger.classList.contains('is-active'));
        if (firstVisible && (!activeTrigger || activeTrigger.hidden)) {
          activateBrand(firstVisible.dataset.brandTrigger, false);
        }
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && display.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', (event) => {
        if (!event.matches) closeDrawer();
      });
    }

    activateBrand(triggers[0].dataset.brandTrigger, false);
  });

  qsa('product-recommendations').forEach(async (element) => {
    const url = element.dataset.url;
    if (!url || element.children.length) return;
    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const recommendations = html.querySelector('product-recommendations');
      if (recommendations && recommendations.innerHTML.trim()) {
        element.innerHTML = recommendations.innerHTML;
        initCardPromoRotators(element);
        initCardStockNotify(element);
      }
    } catch (error) {
      element.hidden = true;
    }
  });
})();
